import React from 'react';
import {
  Check,
} from 'lucide-react';

/**
 * Compliance tab — DNC and carrier regulation summary.
 * @returns {JSX.Element}
 */
export default function Compliance() {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <div className="panel p-5">
        <div className="font-display font-bold text-lg mb-3">10DLC Trust Score</div>
        <div className="text-5xl font-display font-bold gradient-text">92</div>
        <div className="text-xs text-white/50 mt-1">Verified · Tier 1 messaging</div>
        <ul className="text-sm text-white/75 mt-4 space-y-2">
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-400" /> A2P 10DLC brand registered</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-400" /> SHAKEN/STIR attested</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-400" /> Carrier filters: 0 violations / 30d</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-400" /> Branded calling enabled</li>
        </ul>
      </div>
      <div className="panel p-5">
        <div className="font-display font-bold text-lg mb-3">TCPA Quiet Hours</div>
        <div className="text-sm text-white/70 mb-3">Outbound calls/SMS pause automatically between 9pm and 8am in the lead's local timezone.</div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="label" htmlFor="qs">Quiet start</label><input id="qs" className="input mt-1" defaultValue="9:00 PM"/></div>
          <div><label className="label" htmlFor="qe">Quiet end</label><input id="qe" className="input mt-1" defaultValue="8:00 AM"/></div>
        </div>
        <div className="font-display font-bold text-sm mt-5 mb-2">DNC / STOP Keywords</div>
        <div className="flex flex-wrap gap-2 text-xs">
          {['STOP', 'STOPALL', 'UNSUBSCRIBE', 'CANCEL', 'END', 'QUIT', 'OPT OUT', 'REVOKE'].map((k) => (
            <span key={k} className="pill-purple">{k}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
